// extracted by mini-css-extract-plugin
export default {"cardMenu":"PanelDeControlScreenComponent_cardMenu__zMoha"};